import { DateInput } from "../../DateInput";

const LABEL = "text-[11px] uppercase tracking-[0.22em] text-slate-500";
const INPUT = "mt-1 w-full border border-slate-300 px-3 py-2.5 rounded-sm";

export const EMPTY_MEETING = {
  title: "",
  meeting_date: "",
  location: "",
  description: "",
  start_time: "",
  end_time: "",
  is_online: false,
  online_link: "",
};

export const meetingPayload = (f) => ({
  ...f,
  start_time: f.start_time || null,
  end_time: f.end_time || null,
  online_link: f.is_online ? f.online_link : null,
});

const Text = ({ label, k, form, set, testid, wide, ...rest }) => (
  <div className={wide ? "md:col-span-2 col-span-2" : undefined}>
    <label className={LABEL}>{label}</label>
    <input data-testid={testid} value={form[k] || ""} onChange={(e) => set(k, e.target.value)}
      className={INPUT} {...rest} />
  </div>
);

const StatusSelect = ({ form, set, prefix }) => (
  <div>
    <label className={LABEL}>Status</label>
    <select data-testid={`${prefix}-status`} value={form.status} onChange={(e) => set("status", e.target.value)}
      className={`${INPUT} bg-white`}>
      <option value="agendada">Agendada</option>
      <option value="realizada">Realizada</option>
      <option value="cancelada">Cancelada</option>
    </select>
  </div>
);

const OnlineToggle = ({ form, set, prefix }) => (
  <div className="md:col-span-2 col-span-2 border-t border-slate-100 pt-3 -mb-1">
    <label className="inline-flex items-center gap-2 cursor-pointer select-none">
      <input data-testid={`${prefix}-is-online`} type="checkbox" checked={!!form.is_online}
        onChange={(e) => set("is_online", e.target.checked)} className="h-4 w-4 accent-[#002776]" />
      <span className="text-sm text-slate-700">Reunião online</span>
    </label>
  </div>
);

// Shared create/edit form. `prefix` drives data-testids ("meeting" | "meeting-edit").
export function MeetingFields({ form, setForm, prefix, minDate, withStatus }) {
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <>
      <Text label="Título *" k="title" form={form} set={set} testid={`${prefix}-title`} wide
        required minLength={3} placeholder="Ex.: AGE 2026 · 2ª Reunião Ordinária" />
      <div>
        <label className={LABEL}>Data *</label>
        <DateInput testid={`${prefix}-date`} required min={minDate} value={form.meeting_date}
          onChange={(v) => set("meeting_date", v)} />
      </div>
      {withStatus && <StatusSelect form={form} set={set} prefix={prefix} />}
      <Text label="Local" k="location" form={form} set={set} testid={`${prefix}-location`}
        wide={withStatus} placeholder="Sede ABLEMP / Videoconferência" />
      <Text label="Início" k="start_time" form={form} set={set} testid={`${prefix}-start-time`} type="time" />
      <Text label="Término" k="end_time" form={form} set={set} testid={`${prefix}-end-time`} type="time" />
      <OnlineToggle form={form} set={set} prefix={prefix} />
      {form.is_online && (
        <Text label="Link da reunião" k="online_link" form={form} set={set} testid={`${prefix}-online-link`}
          wide type="url" placeholder="https://meet.google.com/… ou https://zoom.us/j/…" />
      )}
      <div className="md:col-span-2 col-span-2">
        <label className={LABEL}>Descrição / Observações</label>
        <textarea data-testid={`${prefix}-description`} value={form.description}
          onChange={(e) => set("description", e.target.value)} className={`${INPUT} min-h-[90px]`} />
      </div>
    </>
  );
}
